import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Stack,
  styled,
  Tooltip,
  Typography,
} from '@mui/material';

import { Help } from '@mui/icons-material';
import { HotelAmentityDTO } from '@bandido/shared/dtos';

import { AmenityChip } from '@frontend/features/common/components/AmenityChip';
import { amenities as amenitiesIcons } from '@frontend/assets/amenities';

import { showTextInLanguage } from '../../helpers';


const AmenityListItemHelpIcon = styled(Help)(({ theme }) => ({
  color: theme.palette.text.disabled,
  width: 30,
  height: 30
}));

const AmenityListItemText = styled(Typography)(() => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontSize: 14,
  cursor: 'default'
}));

export const AmenityItem:FC<{amenity: HotelAmentityDTO, showMappingStatus?: boolean}> = ({ amenity, showMappingStatus }) => {
  const { systemMappingKey, texts, code} = amenity;
  const { t, i18n } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      gap={2}
    >
      {systemMappingKey ?
        <AmenityChip
          avatar={amenitiesIcons[systemMappingKey]()}
        /> :
        <AmenityListItemHelpIcon />
      }
      <Stack>
        {systemMappingKey ? (
          <Box
            display="flex"
            alignItems="center"
          >
            <AmenityListItemText
              variant="subtitle1"
              fontWeight={500}
            >
              {t(`hotels.amenities.${systemMappingKey}`)}
            </AmenityListItemText>
          </Box>
        ) : (
          showMappingStatus && <AmenityListItemText variant="subtitle1" >
            {t('hotels.amenities.notMappedYet')}
          </AmenityListItemText>
        )}
        <Tooltip title={texts?.length ? showTextInLanguage(texts, i18n.language) : code}>
          <AmenityListItemText
            variant="body2"
            fontSize={12}
          >
            {texts?.length ? showTextInLanguage(texts, i18n.language) : code}
          </AmenityListItemText>
        </Tooltip>
      </Stack>
    </Box>
  );
};

